import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { SingleDatePicker } from 'react-dates';

const DatePicker = ({ value, onChange }) => {
  const [focused, setFocused] = useState();


  return (
    <SingleDatePicker
      placeholder="Datum"
      focused={focused}
      onFocusChange={e => setFocused(e.focused)}
      date={value}
      onDateChange={onChange}
      keepOpenOnDateSelect={false}
      hideKeyboardShortcutsPanel
      isOutsideRange={() => false}
    />
  );
};

DatePicker.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
};

DatePicker.defaultProps = {
  value: null,
};

export default DatePicker;
